import StatusTableService from 'app/admin/status/service/StatusTableService';
import StatusService from 'app/admin/status/service/StatusService';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';

const config = {
	key: 'statusTable',
	text: 'Status',
	topic: 'status',
	service: StatusService,
	icon: 'person',
	editFormState: item => `/status/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['filter', 'search', 'refresh'/*, 'new'*/],
	filterFields: [],
	rowAction: [],
	columns: [
		{
			key: 'key',
			text: 'Name',
			textKey: 'key',
			type: 'text',
			disablePadding: false
		},
		{
			key: 'value',
			text: 'Value',
			textKey: 'value',
			type: 'text',
			disablePadding: false
		}
	]
};

function StatusTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('statusTable', reducer('statusTable'))(StatusTable);